import { LoaderCircle } from 'lucide-react';
import { cn } from './cn';

export interface SpinnerProps {
  /** Diameter in pixels. Default 24 (matches MUI CircularProgress default). */
  size?: number;
  /** Stroke width passed to the lucide icon. */
  strokeWidth?: number;
  className?: string;
  'aria-label'?: string;
}

/**
 * Loading indicator — replaces MUI <CircularProgress />.
 * Inherits color from `currentColor`; default is the brand orange.
 * Override color via className, e.g. <Spinner className="text-white" />.
 */
export function Spinner({
  size = 24,
  strokeWidth = 2.25,
  className,
  'aria-label': ariaLabel = 'Loading',
}: SpinnerProps) {
  return (
    <LoaderCircle
      size={size}
      strokeWidth={strokeWidth}
      role="status"
      aria-label={ariaLabel}
      className={cn('animate-spin text-primary', className)}
    />
  );
}
